import React from "react";

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        console.error("ErrorBoundary caught an uncaught error:", error, errorInfo);
    }

    handleReload = () => {
        window.location.reload();
    };

    render() {
        if (this.state.hasError) {
            // Render premium, styled fallback UI if there is a crash
            return (
                <div style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100vh",
                    width: "100vw",
                    backgroundColor: "#fcfbf7",
                    fontFamily: "Satoshi, sans-serif",
                    color: "#333",
                    padding: "24px",
                    boxSizing: "border-box",
                    textAlign: "center"
                }}>
                    <div style={{
                        maxWidth: "400px",
                        padding: "32px",
                        background: "#ffffff",
                        borderRadius: "16px",
                        boxShadow: "0 8px 30px rgba(0, 0, 0, 0.04)",
                        border: "1px solid #f1efe8",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center"
                    }}>
                        <img 
                            src={`${process.env.PUBLIC_URL}/Qureal_logo.png`} 
                            alt="Qureal logo"
                            style={{ width: "48px", height: "48px", objectFit: "contain", marginBottom: "16px" }} 
                            onError={(e) => { e.target.style.display = 'none'; }}
                        />
                        <h2 style={{ fontSize: "20px", fontWeight: "600", margin: "0 0 8px 0" }}>
                            Something went wrong
                        </h2>
                        <p style={{ fontSize: "14px", color: "#666", margin: "0 0 24px 0", lineHeight: "1.5" }}>
                            The application encountered an unexpected error. Reloading usually resolves this.
                        </p>
                        <button 
                            onClick={this.handleReload}
                            style={{
                                padding: "10px 24px",
                                backgroundColor: "#00998e",
                                color: "#ffffff",
                                border: "none",
                                borderRadius: "8px",
                                fontSize: "14px",
                                fontWeight: "600",
                                cursor: "pointer",
                                transition: "background-color 0.2s",
                                outline: "none"
                            }}
                            onMouseEnter={(e) => e.target.style.backgroundColor = "#007f76"}
                            onMouseLeave={(e) => e.target.style.backgroundColor = "#00998e"}
                        >
                            Reload Page
                        </button>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
